import type { InvitationsFilters } from '@/api/invitations/invitationQueries';
import { Input } from '@/components/common/Input';
import { useEffect, useState } from 'react';

interface ShowInvitedPatientsFiltersProps {
  filters: InvitationsFilters;
  onFiltersChange: (filters: InvitationsFilters) => void;
}

export function ShowInvitedPatientsFilters({
  filters,
  onFiltersChange,
}: ShowInvitedPatientsFiltersProps) {
  const [nameSearch, setNameSearch] = useState('');
  const [emailSearch, setEmailSearch] = useState('');

  useEffect(() => {
    const timer = setTimeout(() => {
      onFiltersChange({ ...filters, search: nameSearch || undefined });
    }, 500);
    return () => clearTimeout(timer);
  }, [nameSearch]);

  useEffect(() => {
    const timer = setTimeout(() => {
      onFiltersChange({ ...filters, email: emailSearch || undefined });
    }, 500);
    return () => clearTimeout(timer);
  }, [emailSearch]);

  return (
    <div className="flex flex-wrap gap-4 pt-2.5">
      <div className="w-56">
        <Input
          id="invited-name-filter"
          label="Filter by Name"
          placeholder="Filter by Name"
          className="bg-white"
          value={nameSearch}
          onChange={(e) => setNameSearch(e.target.value)}
        />
      </div>
      <div className="w-56">
        <Input
          id="invited-email-filter"
          label="Filter by Email"
          placeholder="Filter by Email"
          className="bg-white"
          value={emailSearch}
          onChange={(e) => setEmailSearch(e.target.value)}
        />
      </div>
    </div>
  );
}
